export enum PickBonusState
{
	Idle,
	IntroMessage,
	PagePrepare,
	LevelMessage,
	Pick,
	RevealPicked,
	RevealRemaining,

	PickedMessage,
	FinalMessage,
}